<template>
    <div class="pagination">
      <button 
        class="page-btn" 
        :disabled="currentPage === 1" 
        @click="changePage(currentPage - 1)">
        السابق
      </button>
      <button 

        v-for="page in paginationPages" 
        :key="page.key" 
        :class="['page-btn', { active: currentPage === page.num, ellipsis: page.ellipsis }]" 
        @click="!page.ellipsis && changePage(page.num)"
        :disabled="page.ellipsis"
      >
        {{ page.ellipsis ? '...' : page.num }}
      </button>
      <button 
        class="page-btn" 
        :disabled="currentPage === totalPages" 
        @click="changePage(currentPage + 1)">
        التالي
      </button>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue';

  const props = defineProps({
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  });
  
  const emit = defineEmits(['page-changed']);
  
  const changePage = (page) => {
    emit('page-changed', page);
  };

  const siblingCount = 2;

  const paginationPages = computed(() => {
    const pages = [];
    const total = props.totalPages;
    const current = props.currentPage;
    const first = 1;
    const last = total;

    if (total <= 7) {
      for (let i = 1; i <= total; i++) {
        pages.push({ num: i, ellipsis: false, key: i });
      }
      return pages;
    }

    pages.push({ num: first, ellipsis: false, key: 'first' });

    let left = Math.max(current - siblingCount, 2);
    let right = Math.min(current + siblingCount, total - 1);

    if (left > 2) {
      pages.push({ num: null, ellipsis: true, key: 'left-ellipsis' });
    }

    for (let i = left; i <= right; i++) {
      pages.push({ num: i, ellipsis: false, key: i });
    }

    if (right < total - 1) {
      pages.push({ num: null, ellipsis: true, key: 'right-ellipsis' });
    }

    pages.push({ num: last, ellipsis: false, key: 'last' });

    return pages;
  });
  </script>
  
  <style scoped>
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    flex-wrap: wrap;
  }
  
  .page-btn {
    background-color: var(--main-color);
    color: var(--text-color);
    border: 1px solid var(--scond-color);
    padding: 10px 15px;
    margin: 0 5px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
  }
  
  .page-btn:disabled {
    background-color: var(--section-background);
    color: var(--main-color);
    cursor: not-allowed;
  }
  
  .page-btn.active {
    background-color: var(--scond-color);
    color: var(--main-color);
  }
  
  .page-btn:hover:not(:disabled) {
    background-color: var(--scond-color);
    color: var(--main-color);
  }

  .page-btn.ellipsis {
    min-width: 32px;
    padding: 10px 5px;
    pointer-events: none; /* Already disabled, but for extra safety */
    cursor: default;
  }
  </style>